export default "__VITE_ASSET__X$NiZOIh__"